var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPower(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_850_9007)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 9.67969C21 10.2266 21 10.7735 21 11.3204C20.9863 11.3474 20.9646 11.3733 20.9601 11.4019C20.8895 11.8528 20.8422 12.3085 20.7486 12.7546C19.8717 16.9331 16.2545 20.3087 12.0521 20.8811C11.7804 20.9181 11.5095 20.9602 11.2383 21C10.7188 21 10.1992 21 9.67975 21C9.64578 20.9861 9.61297 20.9652 9.57763 20.9593C9.0471 20.8693 8.50754 20.8164 7.98679 20.6874C3.85376 19.6645 0.748492 16.2404 0.115022 12.0302C0.0813305 11.8065 0.0385595 11.5843 0 11.3613C0 10.7871 0 10.2129 0 9.63867C0.0311758 9.45599 0.0662895 9.27386 0.0929257 9.09047C0.428093 6.78248 1.40225 4.78761 3.04505 3.13125C4.77153 1.3906 6.85621 0.367765 9.29448 0.0735639C9.41049 0.0596168 9.52398 0.0249953 9.63867 0C10.1856 0 10.7324 0 11.2793 0C11.3061 0.0133454 11.3316 0.033637 11.3598 0.0389424C12.0621 0.170045 12.7816 0.241257 13.4643 0.439086C17.3728 1.57175 20.2712 4.92309 20.8841 8.96976C20.92 9.20681 20.9612 9.44309 21 9.67969ZM10.5153 1.23204C5.41392 1.21936 1.24566 5.37355 1.23183 10.4843C1.21799 15.5833 5.37377 19.7532 10.4841 19.768C15.5835 19.7827 19.7531 15.6269 19.7681 10.5151C19.7829 5.41589 15.6255 1.24479 10.5153 1.23204Z",
    fill: "#F82643"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4938 15.0708C8.62024 15.0472 6.9421 13.8933 6.25388 12.1363C5.57928 10.4142 6.04665 8.4286 7.4023 7.15729C7.75235 6.82907 8.15648 6.89169 8.36383 7.11873C8.61602 7.39488 8.57303 7.75006 8.25039 8.0552C6.93674 9.29748 6.79749 11.284 7.96904 12.6359C8.88966 13.6982 10.0765 14.0731 11.4257 13.6764C12.7699 13.2812 13.5746 12.3378 13.781 10.9438C13.9499 9.80318 13.5654 8.83378 12.7337 8.04246C12.5366 7.85486 12.4537 7.63789 12.5248 7.37852C12.5924 7.13218 12.7709 6.98992 13.0204 6.94633C13.2225 6.911 13.3944 6.98287 13.5457 7.11659C16.0862 9.36218 15.2681 13.6187 12.073 14.7654C11.8431 14.848 11.6057 14.9179 11.3659 14.9626C11.0786 15.0162 10.7848 15.0362 10.4938 15.0708Z",
    fill: "#F82643"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.88469 7.21524C9.88469 6.68957 9.88354 6.16385 9.88507 5.63818C9.88622 5.24126 10.1381 4.96364 10.4955 4.96096C10.8535 4.95833 11.114 5.23585 11.1146 5.62938C11.1164 6.68755 11.1164 7.74572 11.1146 8.80389C11.1139 9.1967 10.8521 9.47455 10.494 9.47111C10.1367 9.46761 9.88611 9.19003 9.88507 8.79229C9.88365 8.26657 9.88469 7.74085 9.88469 7.21524Z",
    fill: "#F82643"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_850_9007"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPower);
export default __webpack_public_path__ + "static/media/power.5e0b53487dbcc37ee12a12790f1df916.svg";
export { ForwardRef as ReactComponent };